module.exports = __webpack_public_path__ + "assets/img/package-student.9ab9cb0b.svg";